import React, { useMemo } from 'react';

// TODO: check types, its temporary
import DialogDraggable from 'components/mui/Dialog/DialogDraggable';
import DialogTitle from 'components/mui/Dialog/DialogTitle';
import DialogActions from 'components/mui/Dialog/DialogActions';
import DialogContentMui from '@mui/material/DialogContent';
import PaperComponent from 'components/mui/Dialog/PaperDraggable';

const Dialog = ({
  children,
  open,
  title,
  okText,
  cancelText,
  onClose,
  onOk,
  withActions = true,
  withContent = true,
  disableBackdropClose = false,
  draggable = true,
  forFormID = undefined,
  dividers = false,
  withCloseBtn = false,
  okBtnProps,
  ...rest
}) => {
  const handleOnClose = (event, reason) => {
    if (disableBackdropClose && reason === 'backdropClick') return;

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const PaperComponentProps = useMemo(() => (draggable ? { PaperComponent } : {}), [draggable]);

  return (
    <DialogDraggable
      fullWidth
      open={open}
      maxWidth="xs"
      scroll="paper"
      onClose={handleOnClose}
      {...PaperComponentProps}
      {...rest}
    >
      <DialogTitle onClose={onClose} draggable={draggable} withCloseBtn={withCloseBtn}>
        {title}
      </DialogTitle>

      {withContent ? <DialogContentMui dividers={dividers}>{children}</DialogContentMui> : children}

      {withActions && (
        <DialogActions
          onCancel={onClose}
          onOk={onOk}
          okText={okText}
          cancelText={cancelText}
          forFormID={forFormID}
          okBtnProps={okBtnProps}
        />
      )}
    </DialogDraggable>
  );
};

export default Dialog;
